export function StringBoolean(val: string) {
  if (val === 'true') return true
  if (val === 'false') return false
  if (val === '') return false

  return undefined
}
